import * as Yup from 'yup';
import moment from 'moment';

import { translate } from 'helpers/intl';
import messages from 'containers/SignupPages/PersonalInfo/messages';

export default (props: any) =>
  Yup.object().shape({
    cin: Yup.string().required(translate({ ...messages.requiredField }, props)),
    birthday: Yup.string().test(
      'is-42',
      translate({ ...messages.birthdayInputError }, props),
      (value) => {
        return moment().diff(moment(value), 'years') >= 15;
      },
    ),
  });
